import { Container } from "react-bootstrap";

const OcrCaseStudy = () => {
    return (
        <section className="case-study-content-block py-5">
            <Container>
                <div>
                    <h2 className="text-primary ft-wt-700 mb-4">
                        Machine Learning-Based Document Processing Using OCR
                    </h2>

                    <h3 className="text-primary ft-wt-700 mb-3">The Challenge</h3>

                    <p>
                        The client faced significant delays and costs due to the manual
                        handling of unstructured documents. Files came in different formats
                        and languages, often with inconsistent layouts or poor scan quality.
                        Sensitive fields like personal details, account numbers, or billing
                        information required high accuracy and secure handling. Manual
                        validation was not only time-consuming but also failed to scale as
                        document volume increased, affecting operational efficiency.
                    </p>

                    <h3 className="text-primary ft-wt-700 mb-3">The Solution</h3>

                    <p>
                        We developed an intelligent OCR pipeline using a combination of
                        Tesseract and Google Vision API, along with custom pre-processing
                        logic for image enhancement, skew correction, and noise reduction.
                        Natural Language Processing (NLP) models were used to extract and
                        label key fields, adapting to varying formats and document types. A
                        confidence scoring mechanism was added to flag uncertain results for
                        manual review. The system was integrated into a dashboard that
                        allowed real-time tracking, validation, and export of structured
                        data into downstream applications.
                    </p>

                    <h3 className="text-primary ft-wt-700 mb-3">The Benefits</h3>

                    <p>Key advantages achieved with the solution include:</p>
                    <ul>
                        <li>Boosted document processing efficiency by over 80%</li>
                        <li>Achieved 92%+ data accuracy across various document types</li>
                        <li>Significant reduction in manual effort and turnaround time</li>
                        <li>Scalable to support thousands of documents daily</li>
                        <li>Improved compliance with secure, auditable workflows</li>
                    </ul>
                </div>
            </Container>
        </section>
    );
};

export default OcrCaseStudy;
